import React, { useState } from "react";

import * as S from "./styles";

const ContainerWithTabs = ({
  mt,
  tabs,
  defaultTabIndex = 0,
  fitContent,
  // Conteúdo opcional exibido ACIMA das abas — usado pelo detalhe do projeto
  // para mostrar de qual projeto se trata (pedido do cliente, 18/08/2026).
  // Sem a prop nada muda para os outros usos.
  header = null,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultTabIndex);

  return (
    <S.Wrapper mt={mt} fitContent={fitContent} $hasHeader={Boolean(header)}>
      {header ? <S.TopHeader>{header}</S.TopHeader> : null}
      <S.Header>
        {tabs.map((tab, i) => (
          <S.Tab
            key={tab.title}
            $active={i === selectedTabIndex}
            onClick={() => {
              setSelectedTabIndex(i);
              tab.onClick && tab.onClick();
            }}
          >
            {tab.title}
          </S.Tab>
        ))}
      </S.Header>
      <S.Content>{tabs[selectedTabIndex].component}</S.Content>
    </S.Wrapper>
  );
};

export default ContainerWithTabs;
